import { VERTICAL_NAV_GROUP, EXPANDABLE_NAV_GROUP, EXPANDABLE_NAV_GROUP_MAX_INITIAL_DISPLAY_ITEMS } from '../constants';
const getVisibleChildrenWithoutGroups = navItem => {
  if (!navItem.children) return [];
  return navItem.children.reduce((acc, child) => {
    if (child.id.startsWith(VERTICAL_NAV_GROUP)) {
      acc = acc.concat(child.children);
      return acc;
    }
    if (child.id.startsWith(EXPANDABLE_NAV_GROUP)) {
      if (child.isExpanded) {
        acc = acc.concat(child.children);
      } else {
        acc = acc.concat(child.children.slice(0, EXPANDABLE_NAV_GROUP_MAX_INITIAL_DISPLAY_ITEMS));
      }
      acc.push({
        id: `${child.id}-trigger`,
        children: []
      });
      return acc;
    }

    // to account for tertiary nav items
    if (child.children.length > 0) {
      acc = acc.concat([child, ...getVisibleChildrenWithoutGroups(child)]);
      return acc;
    }
    acc.push(child);
    return acc;
  }, []);
};
export default getVisibleChildrenWithoutGroups;